<template>
  <div class="animated fadeIn" v-if="this.pdfPath" id="coupons">
    <h1>Cupão Vila Galé</h1>

    <div class="redencao-text">
      <div class="container redencao-wrapper">
        <div class="image-area">
          <img src="/vila.png" alt="Vila Galé" class="side-image" />
        </div>

        <div class="text-area">
          <h2 class="redeem-title">
            <a
              href="#"
              @click.prevent="openPdf"
              class="redeem-link"
            >
              Ver cupão
            </a>
          </h2>
        </div>
      </div>
    </div>

    <!-- Popup PDF -->
    <div v-if="showPdf" class="popup-overlay" @click.self="closePdf">
      <div class="pdf-popup">
        <div class="pdf-header">
          <h3>Cupão <br>Vila Galé</h3>
          <div class="pdf-controls">
            <button @click="zoomOut">−</button>
            <span>{{ (zoom * 100).toFixed(0) }}%</span>
            <button @click="zoomIn">+</button>
            <button class="close-btn" @click="closePdf">✖</button>
          </div>
        </div>

        <div
          class="pdf-frame-container"
          ref="scrollContainer"
          @mousedown="startDrag"
          @mouseup="stopDrag"
          @mouseleave="stopDrag"
          @mousemove="drag"
        >
          <iframe
            v-if="pdfPath"
            ref="pdfFrame"
            :src="pdfPath"
            frameborder="0"
            class="pdf-frame"
            :style="{ transform: `scale(${zoom})`, transformOrigin: 'top left' }"
          ></iframe>
          <p v-else>Não foi possível carregar o cupão.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="animated fadeIn" v-else="!this.pdfPath" id="coupons">
    <h1>Cupão Vila Galé</h1>
Desta vez não tem direito ao voucher Hotel!<br>
Obrigado pelo seu contributo para o sucesso da marca! Esteja atento pois brevemente terá novidades!
  
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      showPdf: false,
      pdfPath: null,
      zoom: 1,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      scrollLeft: 0,
      scrollTop: 0,
    };
  },

  mounted() {
    this.getValePdf();
  },

  methods: {
    async getValePdf() {
      try {
        const response = await axios.get('app/getValePdf');
        const data = response.data;

        if (data.prizes && data.prizes.length > 0 && data.prizes[0].notes) {
          this.pdfPath = data.prizes[0].notes;
        } else {
          console.warn('Nenhum cupão disponível para este utilizador.');
          this.pdfPath = null;
        }
      } catch (error) {
        console.error('Erro ao buscar o cupão:', error);
        this.pdfPath = null;
      }
    },
    openPdf() {
      if (!this.pdfPath) return;
      this.showPdf = true;
      this.zoom = 1;
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        if (container) {
          container.scrollLeft = 0;
          container.scrollTop = 0;
        }
      });
    },

    closePdf() {
      this.showPdf = false;
    },

    zoomIn() {
      if (this.zoom < 2.5) this.zoom += 0.1;
    },

    zoomOut() {
      if (this.zoom > 0.5) this.zoom -= 0.1;
    },

    startDrag(e) {
      this.isDragging = true;
      const container = this.$refs.scrollContainer;
      this.dragStartX = e.pageX - container.offsetLeft;
      this.dragStartY = e.pageY - container.offsetTop;
      this.scrollLeft = container.scrollLeft;
      this.scrollTop = container.scrollTop;
      container.style.cursor = 'grabbing';
    },

    stopDrag() {
      this.isDragging = false;
      const container = this.$refs.scrollContainer;
      container.style.cursor = 'grab';
    },

    drag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const container = this.$refs.scrollContainer;
      const x = e.pageX - container.offsetLeft;
      const y = e.pageY - container.offsetTop;
      const walkX = (x - this.dragStartX) * 1.5;
      const walkY = (y - this.dragStartY) * 1.5;
      container.scrollLeft = this.scrollLeft - walkX;
      container.scrollTop = this.scrollTop - walkY;
    },
  },
};
</script>

<style>

#coupons .redencao-text {
  background: linear-gradient(240.74deg, #C26E00 0%, #AF3F00 100%);
  border-radius: 15px;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  color: #fff;
 
}

.redencao-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;
  padding: 0px;
}

.image-area {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
    padding: 20px;
}

.side-image {
  width: 100%;
  max-width: 381px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
}

.text-area {
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
}

.redeem-title {
  font-size: 20px;
  margin-bottom: 10px;
}

.redeem-link {
  color: #fff;
  text-decoration: underline;
  font-weight: bold;
}

.flex-container-emissao {
  display: flex;
  align-items: center;
  gap: 10px;
}

.text {
  font-size: 16px;
}

.container {
    width: 100%;
    padding-right: 0px;
    padding-left: 0px;
    padding-bottom: 0px;
    margin-right: auto;
    margin-left: auto;
}



.pdf-popup {
  background: #fff;
  border-radius: 10px;
  width: 90%;
  max-width: 900px;
  height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.pdf-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f48c4f;
  color: #fff;
  padding: 10px 15px;
  border-bottom: 1px solid #ddd;
}

.pdf-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pdf-controls button {
  background: #fff;
  color: #f48c4f;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  padding: 4px 8px;
}

.pdf-controls button:hover {
  background: #ffe5d0;
}

.close-btn {
  background: transparent !important;
  color: #fff !important;
  font-size: 18px;
  border: none;
  cursor: pointer;
}

.pdf-frame-container {
  flex-grow: 1;
  overflow: scroll;
  background: #f0f0f0;
  cursor: grab;
}

.pdf-frame {
  width: 100%;
  height: 100%;
  border: none;
  transform-origin: top left;
  transition: transform 0.2s ease;
}
</style>